<div class="d-flex align-items-center justify-content-center h-100 w-100">
  <h1 class="text-center w-75">
    De pagina die je probeert te bezoeken bestaat niet.
  </h1>
</div>